import Flickity from 'flickity';
import imagesLoaded from 'imagesloaded';

// Equal Height Hack.
// See: https://codepen.io/desandro/pen/ZXEGVq
Flickity.prototype._createResizeClass = function() {
	this.element.classList.add('flickity-resize');
};
Flickity.createMethods.push('_createResizeClass');
const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
	if (this.element.classList.contains('flickity-resize')) {
		this.element.classList.remove('flickity-resize');
	}
	resize.call( this );
	if (! this.element.classList.contains('flickity-resize')) {
		this.element.classList.add('flickity-resize');
	}
};
// END Equal Height Hack.

export function initFlickityCardCarousel(cardCarousel) {
	if (cardCarousel) {
		imagesLoaded(cardCarousel, { background: true }, () => {
			new Flickity(cardCarousel, {
				cellSelector: '.pbsm-card', 
				cellAlign: 'left', 
				groupCells: true, 
				draggable: true, 
			});
		});
	}
}

export function initFlickityCardCarousels() {
	const cardCarousels = document.querySelectorAll('.pbsm-card-carousel');
	if (cardCarousels && (cardCarousels.length > 0)) {
		cardCarousels.forEach((cardCarousel, i) => {
			initFlickityCardCarousel(cardCarousel);
		});
	}
}
